import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../../strings/i18n';
import { FAS_CIRCLE_EXCLAMATION } from '../../../../../const/icon-props';
import StatusMessage from '../StatusMessageBox';
const AccessDeniedMessageBox = () => {
    return (_jsx(StatusMessage, { iconTitle: "exclamation circle icon", type: "warning", icon: FAS_CIRCLE_EXCLAMATION, messageTitle: translate('errorMessages.accessDeniedMessageBox.title'), messageDescription: translate('errorMessages.accessDeniedMessageBox.body') }));
};
export default AccessDeniedMessageBox;
